import { type ButtonProps } from "@heroui/react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

import { Button } from "../core/Button";

export const ThemeSwitcher = ({
  compact,
  className,
  onPress,
  ...props
}: ButtonProps & { compact?: boolean }) => {
  const [mounted, setMounted] = useState(false);
  const { resolvedTheme, setTheme } = useTheme();

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const isDarkMode = resolvedTheme === "dark";

  return (
    <Button
      {...props}
      aria-label={isDarkMode ? "Dark theme" : "Light theme"}
      aria-pressed={isDarkMode}
      className={
        compact === undefined
          ? className
          : `${className ? `${className} ` : ""}header-action-button${compact ? " header-action-button--compact" : ""}`
      }
      onPress={(event) => {
        onPress?.(event);
        setTheme(isDarkMode ? "light" : "dark");
      }}
    >
      {isDarkMode ? (
        <Moon aria-hidden="true" size={18} />
      ) : (
        <Sun aria-hidden="true" size={18} />
      )}
      <p className="header-button-label header-button-label--medium">
        {isDarkMode ? "Dark" : "Light"}
      </p>
    </Button>
  );
}
